import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './andromeda.css';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import "./i18n";  // ⬅️ IMPORTANTE: attiva react-i18next

// 🔹 SEO e dati strutturati globali
const GlobalSEO = () => (
  <Helmet>
    {/* Metadati globali */}
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="robots" content="index, follow" />
    <meta name="author" content="Andromeda Programmazione" />
    <meta name="theme-color" content="#0a0a0a" />
    <meta
      name="description"
      content="Andromeda Programmazione - sviluppo siti web e software personalizzati. Soluzioni digitali professionali per aziende e freelance. Contattaci su andromedaprog.it."
    />
    <meta
      name="keywords"
      content="andromeda programmazione, sviluppo web, programmatore Lecce, siti web, software personalizzati, React, Node.js, Spring Boot, web agency"
    />
    <link rel="canonical" href="https://www.andromedaprog.it/" />

    {/* Open Graph (social preview) */}
    <meta property="og:locale" content="it_IT" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Andromeda Programmazione | Sviluppo Web & Software" />
    <meta
      property="og:description"
      content="Realizziamo siti web e soluzioni digitali su misura per aziende e professionisti. Scopri di più su andromedaprog.it"
    />
    <meta property="og:url" content="https://www.andromedaprog.it/" />
    <meta property="og:site_name" content="Andromeda Programmazione" />
    <meta property="og:image" content="https://www.andromedaprog.it/images/andromeda-og.jpg" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Andromeda Programmazione | Sviluppo Web & Software" />
    <meta
      name="twitter:description"
      content="Andromeda Programmazione crea soluzioni digitali moderne per la tua impresa."
    />
    <meta name="twitter:image" content="https://www.andromedaprog.it/images/andromeda-og.jpg" />

    {/* Favicon e manifest */}
    <link rel="icon" href="/favicon.ico" />
    <link rel="apple-touch-icon" href="/logo192.png" />
    <link rel="manifest" href="/manifest.json" />

    {/* Preload risorse principali per migliorare i Core Web Vitals */}
    <link rel="preload" href="/images/chi-sono.png" as="image" />
  
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />

    {/* JSON-LD Schema.org */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Andromeda Programmazione",
        "url": "https://www.andromedaprog.it/",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.andromedaprog.it/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Andromeda Programmazione",
          "url": "https://www.andromedaprog.it/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.andromedaprog.it/images/logo.png"
          }
        }
      })}
    </script>

    <title>Andromeda Programmazione | Siti Web & Software su Misura</title>
  </Helmet>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <GlobalSEO />
    <App />
  </HelmetProvider>
);

// 🔹 Core Web Vitals (opzionale ma utile per SEO tecnica)
/* eslint-disable no-console */

reportWebVitals(console.log);
